
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './Store/index'
import ElementUI from 'element-ui';
import { Loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import Prints from 'vue-print-nb'
// 引入自定义字体图标
import '@/font_icon/iconfont.css';
import TabRoute from './router/TabRoute'
import RouterMethods from './router/RouterMethods'
// import {Base64} from 'js-base64'
// 工具类库
import request from '@/utils/request'; 
import install from '@/utils/install'
// 获取日期插件
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
// 插件
// import Print from 'vue-print-nb'
// Vue.use(Print); //注册
import Print from '@/plugs/print' // 引入打印的js文件
Vue.use(Print) // 注册
// 图表插件
import echarts from "echarts";
Vue.prototype.$echarts = echarts;
// 财务表格输入框插件
import Direction from 'vue-direction-key'
Vue.use(Direction)
// 表格插件
import 'xe-utils'
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import 'vxe-table/lib/index.css'
import 'vxe-table-plugin-element/dist/style.css'
Vue.use(VXETable)
VXETable.use(VXETablePluginElement)
Vue.use(Prints) 
import axios from 'axios'
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

const whiteList = ['/', '/register', '/record'] // 免登录白名单
router.beforeEach((to, from, next) => {
  let flag = window.localStorage.getItem('U_tok_token')
  if (flag) { // 判断状态
    if (to.path === '/') {
      next()
    }
    next()
  } else {
    /* 没有 */
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      next()
    } else {
      next('/') // 否则全部重定向到登录页
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {  //如果未匹配到路由
    next('/home');   //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
  } else {
    next();    //如果匹配到正确跳转
  }
});

Vue.config.productionTip = false

// 引入request 且 挂载在Vue原型上
Vue.prototype.request = request;

Vue.use(router)
Vue.use(TabRoute)
Vue.use(RouterMethods)
Vue.use(ElementUI, { size: 'medium' });
// 组件注册
Vue.use(install); 
new Vue({
  el: '#app',
  router,
  store,
  Loading, //加载
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js